import { withNotifications } from 'components/notifications';
import { withIntl } from 'contexts/intl/intlContext';
import { StreamingProvider } from 'contexts/streaming.context';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import type { Store } from 'redux';
import type { Streaming } from 'utils/streaming/model';

import { App } from './AppWrapper.connected';

export function bootstrapReactApp(rootId: string, reduxStore: Store, streaming: Streaming, env: string) {
  const container = document.getElementById(rootId)!;
  const root = createRoot(container);
  const Application = withIntl(withNotifications(App, streaming));
  root.render(
    <Provider store={reduxStore}>
      <StreamingProvider streaming={streaming}>
        <Application environment={env} Router={HashRouter} />
      </StreamingProvider>
    </Provider>,
  );
}
